import LearnMoreBlogsStyles from "@components/LearnMoreBlogs/LearnMoreBlogsStyles";
import Link from "next/link";
import React from 'react';
import sanitizeHtml from "sanitize-html";

const sanitizeSettings = {
  allowedTags: ['strong'],
};

const LearnMoreBlogs = ({ wwo_section_title, section_subtitle, blogModuleData, isMobile }) => {
  return (
    <LearnMoreBlogsStyles>
      <section className="tax-tips">
        <div className="container blog-container">
          <h2>{wwo_section_title}</h2>

          <div className="products-wrapper">
            <div className="row mb-4">
              {blogModuleData.map((product, index) => (
                <div className="col-12 col-md-4 product" key={index}>
                  <div className="image">
                    <Link href={product.link}>
                      <img src={product._embedded['wp:featuredmedia'][0].source_url} className="product-img" alt={product._embedded['wp:featuredmedia'][0].alt_text} width="500px" height="500px" />
                    </Link>
                  </div>

                  <div className="copy">
                    <Link href={product.link}>
                      <h4 className="product-title"
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(product.title.rendered, sanitizeSettings) }} />
                    </Link>
                    <div
                      className="product-description text-left"
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(product.excerpt.rendered, sanitizeSettings),
                      }}
                    />
                    <Link href={product.link}>
                      <a className="text-center">Read More</a>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </LearnMoreBlogsStyles>
  )
};

export default LearnMoreBlogs;
